import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Form, Input, Table, ConfigProvider, Button, Space, Modal, message, Tag, Select, Card, ColorPicker, Divider,
  Spin, Radio, Tooltip, InputNumber, Dropdown, Typography, BorderBeam, Popover
} from 'antd';
import {
  SearchOutlined, ReadOutlined, FormatPainterOutlined, FileSyncOutlined, DeleteOutlined, QrcodeOutlined, CloseOutlined, ExperimentOutlined,
  FilePptOutlined, CopyOutlined
} from '@ant-design/icons';
import { hnrequest } from '@/utils'
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph } = Typography;

const Aplist = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [formadg] = Form.useForm();
  const [fxd] = Form.useForm();
  const [fch] = Form.useForm();//产品档案修改




  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [openg, setOpeng] = useState(false);
  const [opend, setOpend] = useState(false);
  const [openrz, setOpenrz] = useState(false);
  const [opench, setOpench] = useState(false);



  const [bangm, setbangm] = useState([]);
  const [openResponsive, setOpenResponsive] = useState(false);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [cpgg, setCpgg] = useState([]);// 选中的产品规格
  const [ticks, setticks] = useState([]);
  const [color, setColor] = useState('#1677ff');
  const [coloru, setColoru] = useState('#1677ff');
  const [spinning, setSpinning] = useState(false);

  const [scqname, setScqname] = useState([]);//生产公司名称

  const [bmgz, setBmgz] = useState();// 编码规则


  const bgColor = useMemo(() => {
    return typeof color === 'string' ? color : color.toHexString()
  }, [color]);
  const btnStyle = {
    backgroundColor: bgColor,
  };

  const bgColoru = useMemo(() => {
    return typeof coloru === 'string' ? coloru : coloru.toHexString()
  }, [coloru]);
  const btnStyleu = {
    backgroundColor: bgColoru,
  };


  useEffect(() => {
    setSpinning(true)
    async function getau() {
      const res = await hnrequest.post('/pms_list')
      setbangm(res.rescode)
      setSpinning(false)
      const res2 = await hnrequest.post('/pms_qyms')
      setScqname(res2.rescode)



    }
    getau()
  }, [ticks])

  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/p_adyyxx', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }




  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const [cpd] = Form.useForm();
  const [pdhtml, setPdhtml] = useState("暂无信息");
  const [cplb, setCplb] = useState("暂无信息");
  const [nymz, setNymz] = useState("暂无信息");

  const [nyqzdb, setNyqzdb] = useState("00000000");
  const [nys, setNys] = useState(false);//农药信息显示

  useEffect(() => { cpd.setFieldValue('mcv', typeof color === 'string' ? color : color.toHexString()) }, [cpd, color])
  useEffect(() => { fch.setFieldValue('mcv', typeof coloru === 'string' ? coloru : coloru.toHexString()) }, [fch, coloru])


  const getDecode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  const handleChange = value => {
    setCplb(value)
    console.log(value)
    setNyqzdb("00000000")
  };


  const produceChange = async () => {

    const pdpjson = {
      "pdno": cpd.getFieldValue("pdno").replace(/\s+/g, '').toUpperCase(),
      "sclx": '1'
    };

    const pdres = await hnrequest.post('/p_pd', pdpjson)

    pdres.return_code === "success" && setNyqzdb(pdres.qzdb)
    pdres.return_code === "success" && setNys(true)
    pdres.return_code === "success" && setPdhtml(getDecode(pdres.pdjson))
    pdres.return_code === "success" && setNymz(pdres.pesticideName)
    pdres.return_code === "success" && cpd.setFieldsValue({ 'pdno': pdres.pdno, 'ny_czqy': pdres.czqy, "prodts": pdres.pdjson })

    pdres.return_code === "success" && cpd.setFieldsValue(
      {
        mjson
          :
          [{
            mname: "基本信息", list: [
              { first: "登记证持有人", second: pdres.czqy },
              { first: "农药名称", second: pdres.pesticideName },
              { first: "剂型", second: pdres.jx },
              { first: "质量保证期", second: "2年" },

            ]
          }]
      }
    )



    pdres.return_code === "error" && setPdhtml("请检查登记证号是否正确！")
    pdres.return_code === "error" && setNyqzdb("00000000")
    pdres.return_code === "error" && setNys(false)
    pdres.return_code === "error" && cpd.setFieldsValue({ 'pdno': '', "prodts": '' })
    pdres.return_code === "error" && messageApi.open({ type: pdres.return_code, content: pdres.return_msg, });
  };

  const onFinish = async (props) => {
    setOpenResponsive(false)
    const pad = await hnrequest.post('/p_ad', props)
    setticks(pad.ticks)
    pad.return_code === "error" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });
    pad.return_code === "success" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });
    pad.return_code === "certification_expired" && setOpenrz(true)
    // console.log(JSON.stringify(props), pad);
  };
  // 产品增加
  //增加规格s
  const onFinishadgg = async (e) => {
    setOpeng(false)
    const radg = await hnrequest.post('/p_adgg', e)
    setticks(radg.ticks)
    messageApi.open({ type: radg.return_code, content: radg.return_msg, });
  }
  // 增加规格e

  const cbmgz = (e) => {
    setBmgz(e.target.value)
    // console.log("选择了" + e.target.value)
  } //选择编码规则

  //产品修改 s

  const onFinishch = async (props) => {
    setOpench(false)
    const pad = await hnrequest.post('/p_pmsch', props)
    setticks(pad.ticks)
    pad.return_code === "error" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });
    pad.return_code === "success" && messageApi.open({ type: pad.return_code, content: pad.return_msg, });

    // console.log(JSON.stringify(props), pad);
  };
  // 产品修改e



  // 农药信息修正s
  const nyxiuzheng = async (pd) => {
    const pdpjson = {
      "pdno": pd.toUpperCase(),
      "sclx": '1'
    };

    const pdres = await hnrequest.post('/p_pd', pdpjson)
    pdres.return_code === "success" && fch.setFieldsValue(
      {
        'ny_czqy': pdres.czqy,
        mjson
          :
          [{
            mname: "基本信息", list: [
              { first: "登记证持有人", second: pdres.czqy },
              { first: "农药名称", second: pdres.pesticideName },
              { first: "剂型", second: pdres.jx },
              { first: "质量保证期", second: "2年" },

            ]
          }]
      }
    )


  }
  // 农药信息修正end

  const onFinishxd = async (e) => {
    setOpend(false)
    setSpinning(true)
    const radg = await hnrequest.post('/p_dbxd', e)
    // radg.return_code === "error"  && setticks(radg.ticks)
    radg.return_code === "error" && setSpinning(false)
    radg.return_code === "error" && messageApi.open({ type: radg.return_code, content: radg.return_msg, });
    radg.return_code === "success" && onShengchan({ "dbno": radg.dbno });
    // console.log(radg)
  }
  const onShengchan = async (e) => {
    const scd = await hnrequest.post('/p_dbsc', e)
    scd.return_code === "success" && setSpinning(false)
    messageApi.open({ type: scd.return_code, content: scd.return_msg, });
    console.log(e, scd)
  }




  // 产品添加  按照类别 显示对应input
  const addpms = () => { setOpenResponsive(true) }
  const chgg = async (p1, p2) => {
    const ngmsj = { gms: p1 };
    const njson = Object.assign(p2, ngmsj);
    const cg = await hnrequest.post('/p_chgg', njson)
    cg.return_code === "error" && messageApi.open({ type: cg.return_code, content: cg.return_msg, });
  }
  const degg = async (e) => {
    const dg = await hnrequest.post('/p_degg', e)
    dg.return_code === "success" && setOpeng(false)
    messageApi.open({ type: dg.return_code, content: dg.return_msg, });
    setticks(dg.ticks)

  }
  const ppde = async (e) => {
    const dp = await hnrequest.post('/pms_de', e)
    messageApi.open({ type: dp.return_code, content: dp.return_msg, });
    setticks(dp.ticks)
  }

  const ppth = (dw, e) => {

    setccpxx(e)
    // console.log("ppth", dw, e)


    dw === "setyy" && formxf.setFieldsValue({ cpno: e.key })
    dw === "setyy" && setOpen(true)

    dw === "setyy" && chMesyy(e.key)
    dw === "specifications" && chaGuige(e.key)
    dw === "specifications" && setOpeng(true)
    dw === "specifications" && formadg.setFieldsValue({ cpno: e.key, gms: '' })
    dw === "dbsq" && chaGuige(e.key)
    dw === "dbsq" && setOpend(true)
    dw === "dbsq" && fxd.setFieldsValue({ cpno: e.key, dblx: '', ggno: '', dbnum: '' })
    dw === "gai" && setOpench(true)
    dw === "gai" && chMes(e.key, e.pname)
    dw === "fvdel" && ppde(e)
    dw === "dbcopy" && pdbCopy(e.key)
  }



  const pdbCopy = async (k) => {
    const cpno = k;
    const dbc = await hnrequest.post('/pms_copy', { cpno: cpno })

    messageApi.open({ type: dbc.return_code, content: dbc.return_msg, });
    setticks(dbc.ticks)

  }
  const chaGuige = async (e) => {
    const cg = await hnrequest.post('/pms_cgg', { "pno": e })
    cg.return_code === "success" && setCpgg(cg.gjson)
  }

  const chMes = async (cpno, pname) => {
    const cg = await hnrequest.post('/pms_pj', { "cpno": cpno })
    fch.setFieldsValue({ cpno: cpno, p_lb: cg.pjson.p_lb, pname: pname, mcv: color, tags: cg.pjson.tags, mjson: cg.pjson.mjson, dbnum: '' })
    // console.log(cg,pname,tags)
  }
  const chMesyy = async (cpno) => {
    const cg = await hnrequest.post('/pms_pj', { "cpno": cpno })

    cg.pjson.pyyjson !== undefined && formxf.setFieldsValue({ yyjson: cg.pjson.pyyjson })
    cg.pjson.pyyjson === undefined && formxf.setFieldsValue({ yyjson: "" })

  }






  const [lsmx, setChlsmx] = useState([]);



  const onmouseenter = (a) => { setChlsmx(a); }

  const handleMenuClick = e => {
    // console.log('click', e.key);
    ppth(e.key, lsmx);
  };


  //  
  const items = [
    {
      key: 'dbpc',
      label: <Space><Paragraph>产品编号:{lsmx.key}</Paragraph></Space>,

    },
    {
      type: 'divider',
    },
    {
      key: 'specifications',
      label: <Space><Button color='green' variant="solid" icon={<FilePptOutlined />} size='small' /> <Tooltip title="规格管理" color="green"><Button color="green" variant="filled" size='small'>规格管理</Button></Tooltip></Space>,

    },
    {
      key: 'dbsq',
      label: <Space><Button color="purple" variant="filled" icon={<QrcodeOutlined />} size='small' /> <Button color='purple' variant="filled" size='small'>数据申请</Button></Space>,

    },

    {
      key: 'setyy',
      label: <Space><Button color='cyan' variant="solid" icon={<ExperimentOutlined />} size='small' disabled={lsmx.dblx === "1001" ? false : true} /> <Tooltip title="设置原药信息" color="cyan"><Button color="cyan" variant="filled" size='small' disabled={lsmx.dblx === "1001" ? false : true}>原药信息</Button></Tooltip></Space>,
      disabled: lsmx.dblx === "1001" ? false : true,

    },

    {
      key: 'dbcopy',
      label: <Space><Button color="geekblue" variant="filled" icon={<CopyOutlined />} size='small' /> <Tooltip title="使用当前产品信息创建一个新的产品档案，需适当修改，如：名称" color='geekblue'><Button color='geekblue' variant="filled" size='small'>信息复用</Button></Tooltip></Space>,

    },
    {
      key: 'gai',
      label: <Space><Button color='pink' variant="solid" icon={<FileSyncOutlined />} size='small' /> <Tooltip title="档案修改,修改后也会影响之前数据" color='pink'><Button color='pink' variant="filled" size='small'>档案修改</Button></Tooltip></Space>,

      // extra: '⌘S',
    },

    {
      key: 'fvdel',
      label: <Space><Button color='red' variant="solid" icon={<DeleteOutlined />} size='small' /> <Tooltip title="直接永久删除" color='red'><Button color='red' variant="filled" size='small'>永久删除</Button></Tooltip></Space>,

      // extra: '⌘S',
    },





  ];




  // const setFcolor = (e) => { e.setFieldsValue({ mcv: color }) }

  const columns = [

    {
      title: <BorderBeam><Button type="dashed" onClick={() => addpms()}> + 产品新增</Button></BorderBeam>,
      dataIndex: 'key',
      key: 'key',
      ...getColumnSearchProps('key'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
      render: (_, records) => (
        <Dropdown menu={{ items, onClick: handleMenuClick, }} onMouseEnter={() => { onmouseenter(records) }} >{records.key}</Dropdown>
      ),

    },

    {
      title: '名称',
      dataIndex: 'pname',
      key: 'pname',
      ...getColumnSearchProps('pname'),
      render: (_, record) => (
        <Popover content={`创建时间:${record.wtime}`} >{record.pname}</Popover>
      ),
    },
    {
      title: '农药登记证',
      key: 'nydjz',
      ...getColumnSearchProps('nydjz'),
      dataIndex: 'nydjz',
    },

    {
      title: '持证企业',
      key: 'nyczqy',
      ...getColumnSearchProps('nyczqy'),
      dataIndex: 'nyczqy',
    },
    {
      title: '产品类型',
      dataIndex: 'dblx',
      key: 'dblx',
      render: (_, record) => (

        <Space size="middle">
          {record.dblx === "1001" && <Tag color="volcano" >农药</Tag>}
          {record.dblx === "1003" && <Tag color="green" >种子</Tag>}
          {record.dblx === "1002" && <Tag color="purple" >农肥&其他</Tag>}
          {record.dblx === "1004" && <Tag color="purple" >农肥&其他</Tag>}
        </Space>
      ),
    },

    {
      title: '创建者',
      key: 'note',
      ...getColumnSearchProps('note'),
      dataIndex: 'note',
    },
    {
      title: '标签',
      key: 'tags',
      ...getColumnSearchProps('tags'),
      dataIndex: 'tags',
      render: (_, { tags }) => (
        <>
          {
            tags.length === 0 ? <Space>——</Space> : tags && tags.map((tag) => {
              let color = tag.length > 5 ? 'geekblue' : 'green';
              if (tag === 'loser') {
                color = 'volcano';
              }
              return (
                <Tag color={color} key={tag}>
                  {tag.toUpperCase()}
                </Tag>
              );
            })}
        </>
      ),
    },

  ];
  // 






  const columnsg = [
    {
      title: 'id',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: '规格描述',
      dataIndex: 'label',
      key: 'label',
      render: (_, z) => <Input
        defaultValue={z.gms}
        onBlur={(e) => chgg(e.target.value, z)}
      />,
    },
    {
      title: 'Action',
      dataIndex: '',
      render: (_, q) => <Link onClick={() => degg(q)}>删除</Link>,
    },
  ];


  // 



  const chnrtest = async (a, b, e) => {
    formxf.setFieldsValue({
      yyjson: {
        [b]: {
          ymsglist: {
            [e]: {
              nr: a.target.value.toUpperCase()
            }
          }
        }
      }
    });


    const pdpjson = {
      "pdno": a.target.value.toUpperCase(),
      "sclx": '1'
    };
    const pad = await hnrequest.post('/p_pd', pdpjson)
    pad.return_code === "success" && formxf.setFieldsValue({
      yyjson: {
        [b]: {
          ymsglist: {
            [e + 1]: {
              nr: pad.pesticideName
            },
            [e + 2]: {
              nr: pad.czqy
            }
          }
        }
      }
    });



  }


  // key


  return (
    <>

      <ConfigProvider locale={zhCN}

        theme={{
          components: {
            Table: {
              rowHoverBg: '#7ed3be',          // 鼠标高亮背景
              rowSelectedHoverBg: '#7ed3be',  // 选中行 hover 背景
            },
          },
        }}
      >
        {contextHolder}
        <Form form={form} component={false}


        >

          <Table size="small"
            columns={columns} dataSource={bangm} pagination={{
              defaultPageSize: 20,                 // 默认 20 条
              showSizeChanger: true,        // 显示“10/20/50/100”下拉
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total) => `共 ${total} 条`,
            }} />


        </Form>




        {/* 认证过期s */}

        <Modal
          title=""
          footer={null}
          // style={{ top: 98 }}
          open={openrz}
          // onOk={() => onFxfsq()}

          onCancel={() => setOpenrz(false)}
        // width={1000}
        >


          <Link to={'/hn/uc/un/uname'} >
            <Button type="link" color="danger" block style={{ fontSize: '1.5em' }}>
              认证过期或类别超限   ☞去认证
            </Button>
          </Link>
        </Modal>
        {/* 认证过期e */}



        {/* 下单s */}
        <Modal
          title="数据申请"
          footer={null}
          style={{ top: 98 }}
          open={opend}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpend(false)}
          width={800}
        >
          <Space style={{ paddingBottom: '10px' }}>产品编号：{ccpxx.key} 产品名称：{ccpxx.pname}</Space>
          <Form
            name="fxd"
            // layout="inline"
            form={fxd}
            onFinish={onFinishxd}
          >

            <Form.Item name='cpno' hidden={true} >
              <Input />
            </Form.Item>


            <Form.Item name="dblx" label="数据类型" rules={[{ required: true, message: '请选择数据类型!' }]} >

              <Radio.Group buttonStyle="solid">
                <Radio.Button value="indb"><Tooltip title="最终销售单元的数据" color='blue' >单元识别码</Tooltip></Radio.Button>
                <Radio.Button value="outdb"><Tooltip title="箱码、垛码、外包装码的数据" color='blue' >集合码</Tooltip></Radio.Button>
              </Radio.Group>




            </Form.Item>

            {ccpxx.dblx === "1001" && <>
              <Form.Item name="sclx" label="生产类型" rules={[{ required: true, message: '请选择编码规则!' }]} >

                <Radio.Group buttonStyle="solid" onChange={cbmgz}
                >
                  <Radio.Button value="1"><Tooltip title="登记证持有人生产" color='blue' >持证生产</Tooltip></Radio.Button>
                  <Radio.Button value="2"><Tooltip title="委托加工" color='blue' >委托加工</Tooltip></Radio.Button>
                  <Radio.Button value="3"><Tooltip title="委托分装" color='blue' >委托分装</Tooltip></Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item name='scmno'  >
                <Select
                  showSearch={{
                    filterOption: (input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
                  }}
                  style={{ width: '100%' }}
                  placeholder="请选择对应的企业信息！"
                  onChange={value => {
                    console.log(`selected ${value}`);
                  }}
                  options={scqname}
                  optionRender={option => (
                    <Space>

                      {`${option.data.label} (${option.data.value})`}
                    </Space>
                  )}
                />
              </Form.Item>





            </>
            }







            {ccpxx.dblx === "1002" && <>
              <Form.Item name="bmgz" label="编码规则" rules={[{ required: true, message: '请选择编码规则!' }]} >

                <Radio.Group buttonStyle="solid" onChange={cbmgz}
                >
                  <Radio.Button value="2023"><Tooltip title="2023" color='blue' >2023</Tooltip></Radio.Button>
                  <Radio.Button value="2024"><Tooltip title="2024" color='blue' >2024</Tooltip></Radio.Button>
                  <Radio.Button value="2026"><Tooltip title="自定义长度，数据组成" color='blue' >自定义类型</Tooltip></Radio.Button>
                </Radio.Group>




              </Form.Item>

              {bmgz === "2026" && <>



                <Form.Item name="dbtype" label="组成类型" rules={[{ required: true, message: '请选择编码规则!' }]} >
                  <Radio.Group buttonStyle="solid"
                  >
                    <Radio.Button value="dbint"><Tooltip title="纯数字" color='blue' >纯数字</Tooltip></Radio.Button>
                    <Radio.Button value="dbmix"><Tooltip title="数字字母汇合" color='blue' >数字字母汇合</Tooltip></Radio.Button>
                  </Radio.Group>
                </Form.Item>

                <Form.Item name="dblength" label="数据长度" rules={[{ required: true, message: '请填写合适的数据长度数字 范围8~50 !' }]} >

                  <InputNumber min={8} max={50} style={{ width: '100%' }} />
                </Form.Item>

              </>}
            </>



            }

            <Form.Item name="ggno" label="产品规格" rules={[{ required: true, message: '请选择产品规格!' }]} >

              <Select
                showSearch={{ optionFilterProp: 'label' }}
                options={cpgg}
              />



            </Form.Item>

            <Form.Item name="dbnum" label="数据数量" rules={[{ required: true, message: '请填写数据数量!' }]} >

              <InputNumber min='1' max='1000000' step='1000' changeOnWheel style={{ width: '100%' }} />




            </Form.Item>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                提   交
              </Button>
            </Form.Item>
          </Form>




        </Modal>

        {/* 下单e */}

        {/* 规格s */}

        <Modal
          title="规格管理"
          footer={null}
          style={{ top: 98 }}
          open={openg}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpeng(false)}
          width={1000}
        >
          <Form
            name="formadg"
            layout="inline"
            form={formadg}
            onFinish={onFinishadgg}
          >
            <Form.Item name='cpno' hidden={true} >
              <Input />
            </Form.Item>
            <Form.Item name="gms" label="规格" rules={[{ required: true, message: '该信息不能为空!' }]} >
              <Input />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                增加
              </Button>
            </Form.Item>
          </Form>


          <Table dataSource={cpgg} columns={columnsg} showHeader={false} style={{ marginTop: '10px' }} />

        </Modal>

        {/* 规格e */}


        {/*  */}
        <Modal
          title="原药信息维护"
          footer={null}
          style={{ top: 98 }}
          open={open}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={1000}
        >



          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >
            <Form.Item name='cpno' hidden={true} >
              <Input />
            </Form.Item>
            <Form.List name="yyjson" >



              {(fields, { add, remove }) => (


                <div
                  style={{
                    display: 'flex',
                    rowGap: 16,
                    flexDirection: 'column',
                  }}
                >
                  <Space>
                    产品编号：{ccpxx.key} 产品名称：{ccpxx.pname} <Tag icon={<ExperimentOutlined />} color="#69b1ff" onClick={() => add(

                      {
                        ymsglist: [
                          { mc: '登记证号', nr: '' },
                          { mc: '原药名称', nr: '' },
                          { mc: '生产企业', nr: '' },
                        ],
                      }

                    )} > + 原药信息</Tag>

                  </Space>




                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`原药信息 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >
                      <Form.Item label="">
                        <Form.List name={[field.name, 'ymsglist']}>
                          {(subFields, subOpt) => (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 16,
                              }}
                            >
                              {subFields.map((subField) => (
                                <Space key={subField.key}>
                                  <Form.Item
                                    // noStyle
                                    rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'mc']}>
                                    <Input placeholder="类目名称" count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <Form.Item
                                    // noStyle
                                    rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'nr']}>
                                    <Input placeholder="内容" style={{ width: "400px" }} count={{ show: true, }} allowClear className={subField.name === 0 ? 'nydjz' : ''} onBlur={(e) => { subField.name === 0 && chnrtest(e, field.name, subField.name) }} />
                                  </Form.Item>
                                  <CloseOutlined
                                    onClick={() => {
                                      subOpt.remove(subField.name);
                                    }}
                                  />
                                </Space>
                              ))}
                              <Button type="dashed" onClick={() => subOpt.add()} >
                                + 添加项目
                              </Button>
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                    </Card>
                  ))}
                </div>
              )}
            </Form.List>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                style={{ marginTop: "20px" }}
                block={true} >
                提   交
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        {/*  */}
        <Modal
          title="产品新增"
          style={{ top: 78 }}
          open={openResponsive}
          onOk={() => setOpenResponsive(false)}
          onCancel={() => setOpenResponsive(false)}
          footer={null}
          width={'70%'}
          classNames={{
            body: 'my-classname'
          }}

        >

          <Form
            name="cpd"
            form={cpd}
            layout="vertical"
            onFinish={onFinish}
            className='nypd'
          >



            <Form.Item
              name="p_lb"
              rules={[{ required: true, message: '请选择产品类别！' }]}
            >
              <Select
                defaultValue="请选择产品类别"
                style={{ width: 400 }}
                onChange={handleChange}
                options={[
                  { value: '1001', label: <span><Tag color="volcano" >农药</Tag></span> },
                  { value: '1002', label: <span><Tag color="purple" >农肥&其他</Tag></span> },
                  { value: '1003', label: <span><Tag color="green" >种子</Tag></span> },

                ]}
              />
            </Form.Item>



            {cplb === "1001" && <><Form.Item
              label="农药登记证号"
              className='nydjz'
              name="pdno"
              rules={[{ required: true, message: '请填写正确的农药登记证！' }]}
            >
              <Input onBlur={produceChange} />
            </Form.Item>
              <Form.Item
                hidden
                label="持证企业"
                name="ny_czqy"
              >
                <Input />
              </Form.Item>

            </>
            }


            {(cplb === "1001" && nys) &&
              <Space align="center" size={1} className='nyqzdm'>
                <span>前置编码:</span>
                <span><Tag color="#108ee9" >{nyqzdb.substring(0, 1)}</Tag></span>
                <span><Tag color="#2db7f5" >{nyqzdb.substring(1, 7)}</Tag></span>
                {/* <span><Tag color="green" >{nyqzdb.substring(7, 8)}</Tag></span> */}
                <Divider style={{ borderColor: '#7cb305' }} orientation="vertical"></Divider>
                <Popover content={<div className='about' dangerouslySetInnerHTML={{ __html: pdhtml }}></div>} title="农药电子标签"
                  styles={{ root: { minWidth: 280, maxWidth: '60vw', }, }}
                  placement="right"

                ><span>农药名称:</span>
                  <span>{nymz}</span></Popover>
              </Space>
            }









            {/* {(cplb === "1001" && nys) && <div className='about' dangerouslySetInnerHTML={{ __html: pdhtml }}></div>} */}




            {cplb === "1001" && <Form.Item name="prodts" hidden > <Input /></Form.Item>}



            <Form.Item
              label="产品名称"
              name="pname"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>


            <Form.Item
              label="产品标签"
              name="tags"
            >

              <Select
                mode="tags"
                style={{
                  width: '100%',
                }}
                tokenSeparators={[',']}
                placeholder='产品标签，方便查询，不对外展示'
                onInputKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
                onChange={(values) => {
                  const cleaned = values.map(v => v.replace(/\s+/g, ''));
                  form.setFieldValue('tags', cleaned);
                }}

              />
            </Form.Item>

            <Form.Item hidden={true} name='mcv'  >
              <Input /></Form.Item>


            <Form.List name="mjson" >



              {(fields, { add, remove }) => (


                <div
                  style={{
                    display: 'flex',
                    rowGap: 16,
                    flexDirection: 'column',
                  }}
                >

                  {/* <Form.Item label="主题颜色" > */}
                  <Space>

                    <ColorPicker
                      allowClear
                      showText
                      value={color} onChange={setColor}
                    ><Button icon={<FormatPainterOutlined />} type="primary" style={btnStyle}>主体颜色</Button> </ColorPicker>
                    <Button type="dashed" onClick={() => add()} >
                      + 添加模块
                    </Button>




                  </Space>




                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`模块 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >

                      <Form.Item label="模块名称" name={[field.name, 'mname']} >
                        <Input count={{ show: true, }} allowClear />
                      </Form.Item>



                      {/* Nest Form.List */}
                      <Form.Item label="子项信息">
                        <Form.List name={[field.name, 'list']}>
                          {(subFields, subOpt) => (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 16,
                              }}
                            >
                              {subFields.map((subField) => (
                                <Space key={subField.key}>
                                  <Form.Item
                                    noStyle
                                    name={[subField.name, 'first']}>
                                    <Input placeholder="类目名称" count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <Form.Item
                                    noStyle
                                    name={[subField.name, 'second']}>
                                    <Input placeholder="内容" style={{ width: "800px" }} count={{ show: true, }} />
                                  </Form.Item>
                                  <CloseOutlined
                                    onClick={() => {
                                      subOpt.remove(subField.name);
                                    }}
                                  />
                                </Space>
                              ))}
                              <Button type="dashed" onClick={() => subOpt.add()} >
                                + 添加子项目
                              </Button>
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                    </Card>
                  ))}
                </div>
              )}
            </Form.List>
            <Divider />
            <Form.Item>
              <Button type="primary" htmlType="submit" block>增加</Button>
            </Form.Item>

          </Form>
        </Modal>
        {/*  */}
        {/* 产品修改s */}



        <Modal
          title="档案修改"
          style={{ top: 98 }}
          open={opench}
          onOk={() => setOpench(false)}
          onCancel={() => setOpench(false)}
          footer={null}
          width={'70%'}
          classNames={{
            body: 'my-classname'
          }}

        >

          <Form
            name="fch"
            form={fch}
            layout="vertical"
            onFinish={onFinishch}
            className='nypd'
          >



            <Form.Item
              label="产品名称"
              name="pname"
              rules={[{ required: true, },]}
            >
              <Input />
            </Form.Item>


            <Space.Compact>
              {ccpxx.dblx === "1001" && <>
                <Form.Item>
                  <Space align="center" size={12} className='nyqzdm'>
                    <span>农药登记证:{ccpxx.nydjz}</span>

                    <Button type="primary" size='small' onClick={() => nyxiuzheng(ccpxx.nydjz)}>基本信息修正</Button>
                  </Space>
                </Form.Item>
                <Form.Item
                  hidden
                  name="ny_czqy"
                >
                  <Input />
                </Form.Item>
              </>


              }
            </Space.Compact>


            <Form.Item name='cpno' hidden={true} >
              <Input />
            </Form.Item>
            <Form.Item name='p_lb' hidden={true} >
              <Input />
            </Form.Item>

            <Form.Item
              label="产品标签"
              name="tags"
            >

              <Select
                mode="tags"
                style={{
                  width: '100%',
                }}
                tokenSeparators={[',']}
                placeholder='产品标签，方便查询，不对外展示'
                onInputKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
                onChange={(values) => {
                  const cleaned = values.map(v => v.replace(/\s+/g, ''));
                  form.setFieldValue('tags', cleaned);
                }}

              />
            </Form.Item>

            <Form.Item
              hidden={true}
              value={coloru}
              name='mcv'  >
              <Input /></Form.Item>


            <Form.List name="mjson" >



              {(fields, { add, remove }) => (


                <div
                  style={{
                    display: 'flex',
                    rowGap: 16,
                    flexDirection: 'column',
                  }}
                >

                  {/* <Form.Item label="主题颜色" > */}
                  <Space>

                    <ColorPicker
                      allowClear
                      showText
                      value={coloru} onChange={setColoru}
                    ><Button icon={<FormatPainterOutlined />} type="primary" style={btnStyleu}>主体颜色</Button> </ColorPicker>

                    {ccpxx.dblx === "1001" ? <Link to={'/hn/pdt/sup/prodtsy?q=' + ccpxx.key} ><Button icon={<ReadOutlined />} type="primary" >
                      产品详情
                    </Button></Link> : <Link to={'/hn/pdt/sup/prodts?q=' + ccpxx.key} ><Button icon={<ReadOutlined />} type="primary" >
                      产品详情
                    </Button></Link>}



                    <Button type="dashed" onClick={() => add()} >
                      + 添加模块
                    </Button>



                  </Space>


                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`模块 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >

                      <Form.Item label="模块名称" name={[field.name, 'mname']} >
                        <Input count={{ show: true, }} allowClear />
                      </Form.Item>



                      {/* Nest Form.List */}
                      <Form.Item label="子项信息">
                        <Form.List name={[field.name, 'list']}>
                          {(subFields, subOpt) => (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 16,
                              }}
                            >
                              {subFields.map((subField) => (
                                <Space key={subField.key}>
                                  <Form.Item
                                    noStyle
                                    name={[subField.name, 'first']}>
                                    <Input placeholder="类目名称" count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <Form.Item
                                    noStyle
                                    name={[subField.name, 'second']}>
                                    <Input placeholder="内容" style={{ width: "800px" }} count={{ show: true, }} />
                                  </Form.Item>
                                  <CloseOutlined
                                    onClick={() => {
                                      subOpt.remove(subField.name);
                                    }}
                                  />
                                </Space>
                              ))}
                              <Button type="dashed" onClick={() => subOpt.add()} >
                                + 添加子项目
                              </Button>
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                    </Card>
                  ))}
                </div>
              )}
            </Form.List>
            <Divider />
            <Form.Item>
              <Button type="primary" htmlType="submit" block>修改</Button>
            </Form.Item>

          </Form>
        </Modal>

        {/* 产品修改e */}
        <Spin spinning={spinning} description="数据整理中，请稍等..." fullscreen />
      </ConfigProvider>
    </>

  );
};
export default Aplist;